import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ProgramsSection from "./components/ProgramsSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  const phoneNumber = "919681125006"; // 🔁 Replace with your number (include country code without +)
  const message = "Hi, I’m interested in joining The Fitness Junction. Please share details.";

  return (
    <div className="bg-black text-white overflow-x-hidden">
      <Header />

      <main className="pt-20">
        <HeroSection />
        <ProgramsSection />
        <AboutSection />
        <ContactSection />
      </main>

      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 
                   bg-green-500 hover:bg-green-600 
                   p-4 rounded-full shadow-2xl 
                   transition-all duration-300 
                   hover:scale-110"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="28"
          height="28"
          fill="white"
        >
          <path d="M16 .4C7.4.4.4 7.4.4 16c0 2.8.7 5.5 2.1 7.9L.1 31.9l8.2-2.2c2.3 1.3 4.9 2 7.7 2 8.6 0 15.6-7 15.6-15.6S24.6.4 16 .4zm0 28.7c-2.5 0-5-.7-7.1-2l-.5-.3-4.9 1.3 1.3-4.8-.3-.5c-1.3-2.2-2-4.6-2-7.1 0-7.3 6-13.3 13.3-13.3s13.3 6 13.3 13.3-6 13.3-13.3 13.3zm7.5-9.9c-.4-.2-2.3-1.1-2.6-1.3-.4-.1-.6-.2-.8.2s-.9 1.3-1.1 1.6-.4.3-.8.1c-.4-.2-1.7-.6-3.2-2-1.2-1.1-2-2.4-2.2-2.8s0-.6.2-.8c.2-.2.4-.4.6-.6.2-.2.2-.4.4-.6.1-.2.1-.4 0-.6s-.8-2-1.1-2.7c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 3s1.2 3.5 1.4 3.8c.2.3 2.3 3.6 5.6 5 3.3 1.4 3.3.9 3.9.8.6-.1 2.3-.9 2.6-1.7.3-.8.3-1.5.2-1.7-.1-.2-.3-.3-.7-.5z" />
        </svg>
      </a>
    </div>
  );
}

export default App;
